export function isPublicQuoteRoute(pathname: string): boolean {
  const p = pathname.toLowerCase();
  return p === '/q' || p.startsWith('/q/');
}

export function hasQuoteToken(pathname: string): boolean {
  return /^\/q\/[^/]+/i.test(pathname);
}

export function isOfflineEventRoute(pathname: string): boolean {
  return /^\/events\/offline(?:\/[0-9a-f-]+)?\/?$/i.test(pathname);
}
